import { Checkbox } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import type { UseFormRegister } from 'react-hook-form';

import { useWebviewThemeParameter } from '../../../lib/useThemeParamter';

export interface AllowedMarketingFormValue {
  allowedMarketing: boolean;
}

export type AllowedMarketingCheckBoxProps<T> = T extends AllowedMarketingFormValue
  ? {
      register: UseFormRegister<T>;
    }
  : never;

export const AllowedMarketingCheckBox = <T extends AllowedMarketingFormValue>({
  register,
}: AllowedMarketingCheckBoxProps<T>) => {
  const { t } = useTranslation();
  const { isDarkTheme } = useWebviewThemeParameter();

  return (
    <Checkbox
      {...register('allowedMarketing')}
      color={isDarkTheme ? 'infgreen.7' : 'infgreen'}
      size="xs"
      radius="sm"
      label={t('통합회원 할인 혜택 및 유용한 채용 소식을 받아볼래요.')}
    />
  );
};
